@let siteBudgetGrid = siteBudgetGridComponent();

<div class="flex justify-end space-x-4">
  @if (editMode()) {
    @if (isSiteInvoiceables()) {
      <aux-button
        variant="negative"
        label="Delete"
        [disabled]="!siteBudgetGrid.selectedRows().length || isDataProcessing()"
        (click)="onDeleteRows()"
      />
      <div class="mx-2 h-[40px] border-l"></div>
      <aux-button-group
        label="New Row"
        [options]="addNewRowsOptions"
        [disabled]="isDataProcessing()"
      />
    }

    <aux-button
      icon="X"
      label="Cancel"
      variant="secondary"
      [disabled]="disabled() || isDataProcessing()"
      (click)="cancelChanges.emit()"
    />
    <aux-button
      icon="Check"
      label="Save"
      variant="success"
      (click)="saveChanges.emit()"
      [disabled]="isDataProcessing()"
    />
  } @else {
    @let reasonsToDisable = siteWorkflow.updateSiteCostTooltips();

    <aux-button
      icon="Pencil"
      label="Edit"
      variant="secondary"
      (click)="edit.emit()"
      [disabled]="siteWorkflow.disabledUpdateSiteCostUI() || isDataProcessing() || disabled()"
      [auxTooltip]="reasonsToDisable.length === 1 ? reasonsToDisable[0] : ''"
      [template]="reasonsToDisable.length > 1 ? tooltipTemplate : undefined"
    />

    <ng-template #tooltipTemplate>
      <aux-errors-tooltip [errors]="reasonsToDisable" />
    </ng-template>
  }
</div>
